var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6326",
    "data-name": "Rectangle 6326",
    width: 40.024,
    height: 29.11,
    fill: "#c8d1ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34915",
    "data-name": "Group 34915",
    transform: "translate(-4378 -5530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6350",
    "data-name": "Rectangle 6350",
    width: 74,
    height: 74,
    rx: 12,
    transform: "translate(4378 5530)",
    fill: "#f1f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34904",
    "data-name": "Group 34904",
    transform: "translate(4395 5552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34874",
    "data-name": "Group 34874",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24388",
    "data-name": "Path 24388",
    d: "M28.481,16.5h-.449a13.89,13.89,0,0,1-5.78,9.506A13.728,13.728,0,0,1,12.9,28.565,14.1,14.1,0,1,1,26.644,8.031c.056-.169.1-.3.142-.43A20,20,0,0,1,30.33.608c.092-.115.167-.273.288-.331.226-.108.521-.269.712-.2s.309.385.441.6c.036.06.007.159.007.239q0,12.92,0,25.841a2.17,2.17,0,0,1-1.426,2.167,2.047,2.047,0,0,1-2.759-1.961c.044-1.126.181-2.249.282-3.372q.3-3.331.6-6.661c.012-.131,0-.264,0-.432m-1.717.089c-.972-.238-1.246-.558-1.163-1.521.13-1.51.323-3.015.477-4.523a1.4,1.4,0,0,0-.052-.618,12.809,12.809,0,0,0-24.507,7.14,12.288,12.288,0,0,0,8.722,9.68,12.362,12.362,0,0,0,12.618-2.821,12.229,12.229,0,0,0,3.9-7.336M30.436,2.63c-2.532,3.818-3.412,8.088-3.6,12.574h3.6ZM29.773,16.5c-.123,1.365-.244,2.7-.364,4.034-.192,2.137-.391,4.274-.574,6.411a.815.815,0,0,0,.958.906c.458-.072.722-.449.723-1.05q0-4.971,0-9.942c0-.116-.017-.232-.027-.359Z",
    transform: "translate(0 -0.015)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24389",
    "data-name": "Path 24389",
    d: "M49.2,5.994h.814V5.555c0-1.6,0-3.2,0-4.8,0-.343.088-.615.448-.718a.6.6,0,0,1,.786.609c.014.591.005,1.182.005,1.773q0,2,0,3.991a3.778,3.778,0,0,1-2.873,3.962.557.557,0,0,0-.105.063v4.979c.039.023.062.048.084.047.776-.006.994.062,1.069,1.02.208,2.664.462,5.325.679,7.988a11.923,11.923,0,0,1,.074,2.363A2.565,2.565,0,0,1,47.449,29.1a2.64,2.64,0,0,1-2.438-2.8c.08-1.488.231-2.972.357-4.458q.235-2.77.477-5.539c.058-.673.194-.8.871-.83.078,0,.156-.017.246-.028A1.775,1.775,0,0,0,47,15.2c0-1.505,0-3.01.005-4.515,0-.21-.074-.295-.28-.358a3.738,3.738,0,0,1-2.719-3.594c-.036-2-.014-4-.009-6.005,0-.467.244-.716.641-.709s.616.256.617.734c.005,1.572,0,3.144,0,4.716v.513h.812V5.547c0-1.6-.012-3.2.013-4.8a.9.9,0,0,1,.3-.638c.411-.3.917.034.921.583.01,1.491,0,2.983,0,4.474v.822h.627V5.539c0-1.6,0-3.2,0-4.8,0-.592.539-.948.959-.614a1,1,0,0,1,.287.695c.026,1.45.013,2.9.013,4.353,0,.265,0,.53,0,.819M47.063,16.735c-.2,2.306-.391,4.564-.584,6.822-.078.909-.174,1.816-.23,2.726a1.284,1.284,0,0,0,1.275,1.482A1.348,1.348,0,0,0,48.935,26.2q-.3-3.689-.623-7.377c-.059-.691-.126-1.382-.191-2.084Zm2.851-9.442H45.365a2.307,2.307,0,0,0,2.091,1.913,2.356,2.356,0,0,0,2.459-1.913",
    transform: "translate(-11.225 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24390",
    "data-name": "Path 24390",
    d: "M25.723,16.121a9.755,9.755,0,1,1-9.739-9.712,9.758,9.758,0,0,1,9.739,9.712M15.97,24.668a8.5,8.5,0,1,0-8.493-8.52,8.481,8.481,0,0,0,8.493,8.52",
    transform: "translate(-1.586 -1.635)",
    fill: "#c8d1ec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.9a9d28edc732ed280011ef85c96eeaae.svg";
export { ForwardRef as ReactComponent };